import { gql } from '../../../../common/functions/gql';
import { AddressSearchFragment } from '../../../plp/query';

const productFragment = gql`
  fragment Product on ProductSearchVariant {
    id
    sku
    attributesRaw {
      name
      value
    }
    prices {
      value {
        currencyCode
        centAmount
        fractionDigits
      }
    }
    assets {
      sources {
        uri
      }
    }
  }
`;

export const ProductSearchFragment = gql`
  fragment ProductSearchFragment on ProductProjectionSearchResult {
    total
    offset
    results {
      categories {
        id
        key
        name
      }
      id
      key
      masterVariant {
        id
        sku
        availability {
          channels {
            results {
              availability {
                availableQuantity
                isOnStock
              }
              channel {
                name
                id
              }
            }
          }
        }
      }
      variants {
        id
        sku
        availability {
          channels {
            results {
              availability {
                availableQuantity
                isOnStock
              }
              channel {
                name
                id
              }
            }
          }
        }
      }
    }
  }
`;

export const FindProductAvailabilityInChannelsQuery = `
  query FindProductAvailabilityInChannelsQuery($queryFilters: [SearchFilterInput!]!, $where: String) {
    channels(where:  $where, limit: 100 ) {
      count
      results {
        ...AddressSearchFragment
      }
    }
    productsByChannel: productProjectionSearch(queryFilters: $queryFilters, staged: false)  {
    ...ProductSearchFragment 
  }
  }
  ${AddressSearchFragment}
  ${ProductSearchFragment}
`;

/**
 * This query is useful to fetch products based on the query filter variables passed
 * Get products by ID, Brand, Category ID
 */
export const PDP_FRAMES_QUERY = gql`
  query GetPDPProducts($queryFilters: [SearchFilterInput!]!, $sort: [String!]!) {
    productProjectionSearch(queryFilters: $queryFilters, sorts: $sort, staged: false ,markMatchingVariants: true, limit:100) {
      results {
        id
        key
        masterVariant {
          ...Product
        }
        variants {
          ...Product
        }
        allVariants (onlyMatching:true) {
          ...Product
        }
      }
    }
  }
  ${productFragment}
`;

export const QUERY_FOR_ORDER_HISTORY = gql`
  query GetPDPProducts($queryFilters: [SearchFilterInput!]!, $sort: [String!]!) {
    productProjectionSearch(queryFilters: $queryFilters, sorts: $sort, staged: false) {
      results {
        id
        key
        variants {
          id
          sku
          attributesRaw {
            name
            value
          }
          assets {
            sources {
              uri
            }
          }
        }
        masterVariant {
          id
          sku
          attributesRaw {
            name
            value
          }
          assets {
            sources {
              uri
            }
          }
        }
      }
    }
  }
`;
